// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"bf83b6a8","447":"5415040e","517":"3b577b25","857":"4f7730c9","978":"0d009e2c"}[chunkId] + ".chunk.js";
};